const useRandomArray = (base, length) => {
  const aux = []
  let randomArray = []
  if (base) {
    if (base.length < length) {
      for (let i = 0; i < base.length; i++) {
        aux.push(i)
      }
    } else {
      while (aux.length < length && aux.length <= base.length) {
        const index = Math.floor(Math.random() * base.length)
        if (!aux.includes(index)) {
          aux.push(index)
        }
      }
    }
    randomArray = aux.map(index => base[index])
  }
  return randomArray
}

export default useRandomArray
